import 'angular:locale/data:pl';
import 'angular:locale/data:en-US';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
